import React, { Component, useContext, useEffect, useRef, useState } from 'react'
import { withRoutePane } from '@/components/hoc/routePane'
import { RProps } from '@/config/props';
import { drawing } from '@/interface/constage';
import { Button, Modal, Spin, message } from 'antd';
import './drawing-list.less';
import axios from '@/config/axios';
import { ViewChange } from './view-change';
import { AmbientLight, Box3, BoxGeometry, BufferGeometry, Camera, DirectionalLight, Color, DoubleSide, Float32BufferAttribute, LessDepth, Mesh, MeshBasicMaterial, MeshPhongMaterial, MeshStandardMaterial, Object3D, OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer } from "three";
import { addMonitorObjectPrimitive, findMonitorObjectPrimitiveByProjectId, findPrimitivesInProject, deleteMonitorObjectPrimitive, updateMonitorObjectPrimitive } from '@/config/api/primitives';
import { MonitorObjectPrimitive, Primitive } from '@/interface/primitive';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import classNames from "classnames";
import { ReactComponent as InfoSvg } from './icons/info.svg';
import { ReactComponent as InfoBlueSvg } from './icons/info-blue.svg';
import { ReactComponent as EditSvg } from './icons/edit-white.svg';
import ConstructOverview from './construct-overview';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { useLocation } from 'react-router-dom';
import { EdgeHighlightRenderer } from "./EdgeHighlightRenderer"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { ProjectContext } from '@/config/context'
import { mobject } from '@/interface/mobject';
import { queryMobjects } from '@/config/api/mobject';
import { MobjectBaseType } from '@/utils/type';
import flushSync from 'react-dom'
import ReactDOM from 'react-dom';
import { ReactComponent as PanSvg } from './icons/pan.svg';
import { ReactComponent as RotateSvg } from './icons/rotate.svg';
import { ReactComponent as PanBlueSvg } from './icons/pan-blue.svg';
import { ReactComponent as RotateBlueSvg } from './icons/rotate-blue.svg';

export const SHOW_TYPE = {
    MONITOR: 0,
    SHOW: 1
}

export const VIEW_STATE = {
    NONE: - 1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
}
export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}
interface IProps extends RProps {

}
interface IState {
    drawings: drawing[]
    isEdit: boolean
    currentDrawing: drawing
    onLinkState: boolean
}

interface MObjectPrimitive extends mobject {
    project_id?: number,//关联信息属于哪个项目
    primitive_uuid?: string,//关联的图元的UUID
}

const projectUuid = "projectUuid"
const modelUuid = "modelUuid"

export const DrawingListPage: React.FC<IState> = (props) => {
    const location = useLocation()
    const projectId = useContext(ProjectContext);//当前项目id
    const viewportId = "viewportId";
    const cameraType = CAMERA_TYPE.Orthographic
    const cameraEdge = 30

    // const stats = useRef<Stats>();
    const camera = useRef<Camera>(null)
    const scene = useRef<Scene>(null)
    const renderer = useRef<WebGLRenderer>(null)
    const viewChange = useRef<ViewChange>(null)
    const edgeRenderer = useRef<EdgeHighlightRenderer>(null)
    // const controls = useRef<OrbitControls>(null)

    const [showInfo, setShowInfo] = useState<boolean>(false); // 展示信息
    const [activeEntityUuid, setActiveEntityUuid] = useState<string>("")
    const activeEntity = useRef<Object3D>(null)

    const [isPopupVisible, setIsPopupVisible] = useState(false);//控制是否显示绑定弹窗
    const [mobjects, setMobjects] = useState<MObjectPrimitive[]>([]);    // 使用状态来存储从后端获取的 mobjects 列表（并补充了图元关联表的相关字段）
    const [selectedMobjectId, setSelectedMobjectId] = useState<number | null>(null); // 存储当前选中的 mobject 的 ID
    const [overviewUpdateTrigger, setOverviewUpdateTrigger] = useState(0);    // 存储修改更新状态信号
    const [loading, setLoading] = useState<boolean>(false)
    // const [loading]

    const [editStates, setEditStates] = useState<number>(0); // 编辑状态 0：默认 1：平移 2：旋转
    const [showType, setShowType] = useState<number>(SHOW_TYPE.SHOW) // 展示类别

    const mobjectsRef = useRef<MObjectPrimitive[]>([])

    const monitorObjectRef = useRef<Object3D[]>([])
    const showObjectRef = useRef<Object3D[]>([])

    const isInit = useRef<boolean>(false)

    useEffect(() => {
        camera.current = createCamera(cameraEdge, cameraType);
        scene.current = initScene()
        renderer.current = createRenderer();

        // 初始化视图控制器
        viewChange.current = new ViewChange(renderer.current.domElement, camera.current, scene.current, changeSelect, resetEdit)

        edgeRenderer.current = new EdgeHighlightRenderer(renderer.current.domElement)

        // 初始化数据与旋转中心
        let allBox: Box3 = new Box3()

        generateData(allBox)
        window.addEventListener('resize', onWindowResize);

        return (() => {
            window.removeEventListener('resize', onWindowResize);
        })
    }, [])

    useEffect(() => {
        if (!(showType == SHOW_TYPE.MONITOR || showType == SHOW_TYPE.SHOW)) return
        if (!isInit.current) return
        let remvoeList = []
        let addList = []
        if (showType == SHOW_TYPE.SHOW) {
            remvoeList = monitorObjectRef.current
            addList = showObjectRef.current
        } else {
            addList = monitorObjectRef.current
            remvoeList = showObjectRef.current
        }
        // 清空场景
        for (let i = 0; i < remvoeList?.length; i++) {
            let midObj = remvoeList[i]
            if (midObj && midObj.parent) {
                midObj.parent.remove(midObj)
            }
        }
        // 添加场景
        let allBox = new Box3()
        for (let i = 0; i < addList?.length; i++) {
            scene.current.add(addList[i])
            allBox.expandByObject(addList[i]);
        }
        allBox.getCenter(viewChange.current.rotateCenter)
        viewChange.current?.showAllEntities(allBox)
        renderer?.current?.render(scene?.current, camera?.current)

    }, [showType])

    const resetEdit = () => {
        setEditStates(0)
    }

    const onWindowResize = () => {
        const root = document.getElementById(viewportId);
        if (!root) return;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (!camera.current) return
        camera.current.left = camera.current.bottom * aspect;
        camera.current.right = camera.current.top * aspect;
        camera.current.updateProjectionMatrix();
        renderer.current.setSize(root.offsetWidth, root.offsetHeight);
        renderer.current.setViewport(0, 0, root.offsetWidth, root.offsetHeight)
    }

    const generateData = (allBox: Box3) => {
        setLoading(true)
        Promise.all([
            queryMobjects({ project_id: projectId }),
            findMonitorObjectPrimitiveByProjectId(projectId)
        ]).then(([mobjectsRes, primitivesRes]) => {
            if (mobjectsRes.status === 200 && primitivesRes.status === 200) {
                const mobjectList: mobject[] = mobjectsRes.data || [];
                const monitorPrimitives: MonitorObjectPrimitive[] = primitivesRes.data || [];
                // 遍历 mobjectList，找到与每个 mobject 匹配的 primitive
                const updatedMobjects = mobjectList.map((mobject) => {
                    const matchingPrimitive = monitorPrimitives.find(
                        (primitive) => primitive.monitor_object_id === mobject.id
                    );

                    // 如果找到匹配项，则将 primitive_uuid 添加到 mobject 中
                    return matchingPrimitive
                        ? { ...mobject, primitive_uuid: matchingPrimitive.primitive_uuid }
                        : mobject;
                });
                setMobjects(updatedMobjects); // 更新 mobjects 状态
                mobjectsRef.current = [...updatedMobjects]
            } else {
                message.error("获取列表或关联数据失败");
            }
            return findPrimitivesInProject(projectUuid, modelUuid, SHOW_TYPE.SHOW)

        }).then(res => {
            let primitiveList: Primitive[] = res.data || []

            for (let i = 0; i < primitiveList.length; i++) {
                let position = new Float32BufferAttribute(primitiveList[i].properties.position, 3)
                let geometry: BufferGeometry = new BufferGeometry()
                geometry.setAttribute("position", position)
                let material = new MeshStandardMaterial({
                    side: DoubleSide,
                    emissive: 0x444444,
                    opacity: primitiveList[i].properties?.opacity || 1,
                    transparent: true,
                    depthFunc: LessDepth,
                    color: primitiveList[i].properties?.color || new Color(0, 0, 0),
                    // polygonOffset: true,    // 启动偏移
                    // polygonOffsetFactor: 10, // 偏移因子，值越大偏移越大
                    // polygonOffsetUnits: 1,  // 偏移单位
                })
                geometry.computeBoundingBox();
                geometry.computeBoundingSphere();
                geometry.computeVertexNormals();
                let midMesh: Mesh = new Mesh(geometry, material)
                midMesh.uuid = primitiveList[i].uuid
                showObjectRef.current.push(midMesh)
                scene.current.add(midMesh)

                let midBox = new Box3().setFromBufferAttribute(position)
                allBox.union(midBox)
            }
            allBox.getCenter(viewChange.current.rotateCenter)
            viewChange.current.showAllEntities(allBox)
            animate()
            return findPrimitivesInProject(projectUuid, modelUuid, SHOW_TYPE.MONITOR)
        }).then(res => {
            let primitiveList: Primitive[] = res.data || []
            for (let i = 0; i < primitiveList.length; i++) {
                let position = new Float32BufferAttribute(primitiveList[i].properties.position, 3)
                let geometry: BufferGeometry = new BufferGeometry()
                geometry.setAttribute("position", position)
                let color
                let isA = false
                if (mobjectsRef.current.find(item => primitiveList[i].uuid == item.primitive_uuid)) {
                    color = new Color(0, 0, 1)
                    isA = true
                } else {
                    color = new Color(0x000000)
                    isA = false
                }
                let material = new MeshStandardMaterial({
                    side: DoubleSide,
                    emissive: isA ? 0x222222 : 0x444444,
                    opacity: isA ? 1 : 0.3,
                    // opacity: 1,
                    transparent: true,
                    depthFunc: LessDepth,
                    color: color,
                    depthTest: !isA
                })
                geometry.computeBoundingBox();
                geometry.computeBoundingSphere();
                geometry.computeVertexNormals();
                let midMesh: Mesh = new Mesh(geometry, material)
                midMesh.uuid = primitiveList[i].uuid
                monitorObjectRef.current.push(midMesh)
                // scene.current.add(midMesh)
                // 更新包围盒
                // let midBox = new Box3().setFromBufferAttribute(position)
                // allBox.union(midBox)
            }
            // allBox.getCenter(viewChange.current.rotateCenter)
            // viewChange.current.showAllEntities(allBox)
            // animate()
        }).finally(() => {
            setLoading(false)
            isInit.current = true
        })
    }

    // 打开弹窗时检查并设置是否选择了监测对象
    const openPopup = () => {
        // 如果 activeEntityUuid 有值，查找对应的 mobject 项
        const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
        if (matchedObject) {
            // 设置 selectedMobjectId 为与 activeEntityUuid 对应的 mobject id
            setSelectedMobjectId(matchedObject.id);
        } else {
            // 如果没有匹配项，则清空 selectedMobjectId
            setSelectedMobjectId(null);
        }
        setIsPopupVisible(true); // 显示弹窗
    };

    // 判断是否可以选中，已绑定的且不是当前 activeEntityUuid 的项目不可选
    const isSelectable = (mobject) => {
        return !mobject.primitive_uuid || mobject.primitive_uuid === activeEntityUuid;
    };

    // 绑定弹窗的选择栏
    const handleRowSelect = (id: number) => {
        if (selectedMobjectId === id) {
            // 如果再次点击同一个 ID，清空选中项
            setSelectedMobjectId(null);
        } else {
            // 否则设置为新的选中项
            setSelectedMobjectId(id);
        }
    };

    // 删除绑定的监测对象
    const handleDelete = () => {
        deleteMonitorObjectPrimitive(activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("删除成功！");
                    setIsPopupVisible(false);
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null); // 清空选中项
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("删除失败，请重试！");
                }
            })
            .catch(error => {
                console.error("删除失败：", error);
                message.error("删除失败，请重试！");
            });
    };

    // 添加监测对象的绑定
    const handleAdd = () => {
        addMonitorObjectPrimitive(projectId, selectedMobjectId, activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("绑定成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项

                    // 更新 mobjects 中对应项的 primitive_uuid
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid }
                                : mobject
                        )
                    );
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("绑定失败，请重试！");
                }
            })
            .catch(error => {
                console.error("绑定失败：", error);
                message.error("绑定失败，请重试！");
            });
    };

    // 更新监测对象的绑定
    const handleUpdate = () => {
        const data = {
            project_id: projectId,
            primitive_uuid: activeEntityUuid,
            monitor_object_id: selectedMobjectId
        };

        updateMonitorObjectPrimitive(activeEntityUuid, data)
            .then(res => {
                if (res.status === 200) {
                    message.success("更新成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null }
                                : mobject
                        ).map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null);
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("更新失败，请重试！");
                }
            })
            .catch(error => {
                console.error("更新失败：", error);
                message.error("更新失败，请重试！");
            });
    };

    // 弹窗点击确认的函数
    const handleConfirmBinding = () => {
        // 判断当前图元是否已经绑定过
        const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
        //删除：判断条件之前绑定过，当前没有选择绑定对象
        if (!selectedMobjectId && matchedObject) {
            // 仅取消绑定
            handleDelete();
            return;
        }
        //更新：判断条件已经绑定对象，但是选择绑定对象与之前不同
        if (matchedObject && selectedMobjectId) {
            // 进行更新绑定
            handleUpdate();
            //新增：判定条件之前没有绑定但是现在选择了绑定对象
        } else if (selectedMobjectId) {
            // 新增绑定
            handleAdd();
        } else {
            message.warning("请选择一个监测对象！");
        }
    };

    // 弹窗点击“取消”时的函数
    const handleCancel = () => {
        setSelectedMobjectId(null);
        setIsPopupVisible(false);
    };

    const oldColor = useRef<Color>(null)
    const oldSelect = useRef<Object3D>(null)
    //点击图元的回调函数
    const changeSelect = (entities: Object3D[]) => {
        // 判断是否选中绑定元素
        let bindEntities = entities.filter(item =>
            mobjectsRef.current.find(mItem => mItem.primitive_uuid == item.uuid) &&
            item.uuid != oldSelect.current?.uuid
        )

        let entity
        if (bindEntities?.length > 0) {
            entity = bindEntities[bindEntities.length - 1]
        }
        // else if (entities?.length > 0) {
        //     entity = entities[0]
        // }

        if (oldSelect.current) {
            oldSelect.current.material.color = oldColor.current
        }
        setActiveEntityUuid(entity?.uuid)
        activeEntity.current = entity
        if (entity) {
            oldColor.current = entity.material.color.clone()
            oldSelect.current = entity
            entity.material.color = new Color(0x00ff00)
        } else {
            // 如果 entity 为空，清空 activeEntityUuid 并隐藏信息
            setActiveEntityUuid("");
            oldColor.current = null
            oldSelect.current = null
        }
    }

    // 监听 activeEntityUuid 的变化，当它更新时检查是否应显示 ConstructOverview
    useEffect(() => {
        if (!(activeEntityUuid?.length > 0)) {
            setShowInfo(false);
        } else {
            // 检查 activeEntityUuid 是否与 mobjects 中的某个 primitive_uuid 匹配
            const matchingObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
            if (matchingObject) {
                setShowInfo(true);
            } else {
                setShowInfo(false);
            }
        }
    }, [activeEntityUuid]);     // 依赖 activeEntityUuid

    const createCamera = (s = 30, cameraType = CAMERA_TYPE.Orthographic) => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (cameraType === CAMERA_TYPE.Orthographic) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0.1, 1e7);
            camera.position.set(-1e7 / 2, -1e7 / 2, 1e7 / 2)
            camera.up.set(0, 0, 1)
            camera.lookAt(0, 0, 0)
            return camera;
        } else if (cameraType === CAMERA_TYPE.Perspective) {
            const fov = 75;
            const camera = new PerspectiveCamera(fov, aspect, 0.1, 1e7);
            camera.position.set(0, 0, 300000)
            camera.lookAt(0, 0, 0)
            return camera;
        }
        return null;
    }

    const createRenderer = () => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        }
        const renderer = new WebGLRenderer({
            antialias: true,
            logarithmicDepthBuffer: true
        });
        // renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        renderer.setClearColor('#f5f5f5', 1.0);
        renderer.autoClear = false;
        renderer.setClearColor('#ffffff', 0);
        renderer.domElement.style.background = '#ffffff';

        renderer.setAnimationLoop(animate);
        root.appendChild(renderer.domElement);
        // renderer.domElement.setAttribute('tabindex', '1');
        // renderer.domElement.style.outline = '0px';
        return renderer;
    }

    const initScene = () => {
        let scene = new Scene();

        // 在初始化部分添加光源
        // 添加光照
        const ambientLight = new AmbientLight(0xffffff, 1);
        scene.add(ambientLight);

        const directionalLight = new DirectionalLight(0xffffff, 1);
        directionalLight.position.set(1, 0, 0).normalize();
        directionalLight.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight);
        const directionalLight1 = new DirectionalLight(0xffffff, 1);
        directionalLight1.position.set(-1, 0, 0).normalize();
        directionalLight1.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight1);
        const directionalLight2 = new DirectionalLight(0xffffff, 1);
        directionalLight2.position.set(0, 1, 0).normalize();
        directionalLight2.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight2);
        const directionalLight3 = new DirectionalLight(0xffffff, 1);
        directionalLight3.position.set(0, -1, 0).normalize();
        // directionalLight3.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight3);
        const directionalLight4 = new DirectionalLight(0xffffff, 1);
        directionalLight4.position.set(-1, -1, -1).normalize();
        directionalLight4.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight4);

        return scene
    }

    const animate = () => {
        renderer.current.render(scene.current, camera.current)
        // controls.current.update();
        // requestAnimationFrame(animate);
        // edgeRenderer.current.render(renderer.current, camera.current, scene.current, cameraEdge, aspect, activeEntity.current)
    }

    // 导入文件
    const onLoadFbxFile = () => {
        const fbxLoader = new FBXLoader();
        fbxLoader.load(
            './model.fbx',
            (fbx) => {
                console.log('FBX model loaded successfully!', fbx);

                // 用来存储所有生成的JSON数据
                const meshData: Primitive[] = [];
                const groupChildren = fbx.children[0]?.children; // 获取第一个 Group 的 children（即 [Mesh, Mesh, Mesh, ...]）
                if (groupChildren && groupChildren.length > 0) {
                    groupChildren.forEach((child: Object3D) => {
                        // 确保 child 是 Mesh 类型并且有材质
                        if (child instanceof Mesh && child.material) {

                            // 创建用于保存每个 Mesh 数据的对象
                            const meshJson: Primitive = {};

                            // 获取 Mesh 的 ID（UUID）
                            meshJson.id = child.uuid;
                            meshJson.uuid = child.uuid;

                            let properties: any = {}
                            // 获取 Mesh 的顶点数据（positions）
                            const positions = (child.geometry.attributes.position.array as Float32Array);
                            properties.positions = Array.from(positions); // 将顶点数据转换为普通数组
                            const color = child.material.color;
                            properties.color = color;

                            meshJson.properties = properties

                            // 将 Mesh 数据对象保存到数组
                            meshData.push(meshJson);
                        }
                    });
                }
                scene.current.add(fbx)

            },
            undefined,
            (error) => {
                console.error('Error loading FBX model:', error);
            }
        );
    }

    useEffect(() => {
        if (!viewChange.current) return
        viewChange.current.changeViewState(editStates)
    }, [editStates])

    return (
        <Spin
            // tip={`加载中 ${progress}%`}
            tip={`加载中`}
            spinning={loading}
            wrapperClassName='drawing-spin-main'
        >
            <div
                className={classNames("draw-main", {
                    "show-panel": showInfo,
                    "draw-main-pan": editStates === 1, // 当 editStates 为 1 时添加 pan 类
                    "draw-main-rotate": editStates === 2 // 当 editStates 为 2 时添加 rotate 类
                })}
            >
                <div className={classNames("icon-group", { "shifted": showInfo })}>
                    <div className={classNames({
                        "icon": true,
                        "selected": showInfo
                    })} onClick={() => setShowInfo(!showInfo)}>
                        {showInfo ? <InfoSvg /> : <InfoBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 1,
                    })} onClick={() => setEditStates(editStates == 1 ? 0 : 1)}>
                        {editStates == 1 ? <PanSvg /> : <PanBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 2,
                    })} onClick={() => setEditStates(editStates == 2 ? 0 : 2)}>
                        {editStates == 2 ? <RotateSvg /> : <RotateBlueSvg />}
                    </div>
                </div>
                <div className='switch-btn-area'>
                    <div className={classNames({
                        'name': true,
                        "name-active": showType == SHOW_TYPE.SHOW
                    })}
                        onClick={() => { setShowType(SHOW_TYPE.SHOW) }}
                    >
                        建筑模型
                    </div>
                    <div className={classNames({
                        'name': true,
                        "name-active": showType == SHOW_TYPE.MONITOR
                    })}
                        onClick={() => { setShowType(SHOW_TYPE.MONITOR) }}
                    >
                        结构模型
                    </div>

                </div>
                <div
                    id={viewportId}
                    className="viewport">
                </div>
                {showInfo && <ConstructOverview
                    key={overviewUpdateTrigger}  // 强制组件重新挂载
                    // overviewUpdateTrigger={overviewUpdateTrigger}  // 添加此属性
                    projectId={Number(projectId)}
                    activeEntityUuid={activeEntityUuid} />}


                <Modal
                    title="绑定监测对象"
                    visible={isPopupVisible}
                    onCancel={() => setIsPopupVisible(false)}
                    footer={[
                        <Button key="close" onClick={handleCancel}>
                            取消
                        </Button>,
                        <Button key="confirm" type="primary" onClick={handleConfirmBinding} disabled={!selectedMobjectId && !mobjects.find(m => m.primitive_uuid === activeEntityUuid)}>
                            确定
                        </Button>
                    ]}
                >
                    <div className="table-container">
                        <div className="table-header">
                            <div className="radio-placeholder"></div>
                            <span>监测对象名称</span>
                            <span>监测类型</span>
                        </div>
                        <div className="table-body">
                            {mobjects.map((mobject) => {
                                const isDisabled = !isSelectable(mobject); // 判断该项是否不可选
                                return (
                                    <div
                                        key={mobject.id}
                                        className={`table-row ${selectedMobjectId === mobject.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                        onClick={() => !isDisabled && handleRowSelect(mobject.id)} // 只有可选项才能点击
                                    >
                                        <input
                                            type="radio"
                                            name="tableRow"
                                            checked={selectedMobjectId === mobject.id}
                                            onChange={() => handleRowSelect(mobject.id)}
                                            disabled={isDisabled} // 禁用已绑定的且不是当前 activeEntityUuid 的项目
                                        />
                                        <span>{mobject.name}</span>
                                        <span>{MobjectBaseType[mobject.type]?.alias || '未知类型'}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal>
            </div>
        </Spin>


    )
}

export default withRoutePane(DrawingListPage, '结构模型');